import $ from 'jquery'
import * as project from './functions'
import './polyfill'


window.onload = () => {
  if($('body').hasClass('loaded')) return
  $('body').addClass('loaded')
  $('#block-pizzighettone-main-menu .block-content').addClass('mobile-hide');
  $('#block-pizzighettone-main-menu').prepend("<h3 class=\"title-menu-mobile\">Menu</h3>");

  project.lazyLoad()
  project.menuResponsive()
  
}


// WEBPACK FOOTER //
// ./src/js/main.js